/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Transworld {
    angular.module('meevo.plugins.transworld', []);
}